// import router from "@/router/index";
import * as model from "@/model/prd/inventoryMgt/FormulaPlanDetails";
import { newEntityStoreHelper } from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
  var filter = Object.assign({}, paginationFilter, model.filter)
  return filter;
}

export default newEntityStoreHelper(() => new model.FormulaPlanDetails(), newFilter)

  .withStates({
    idReport: 2,
    baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/inventory",
  }) //TODO load at the application start.
  .withActions({
    Save(context, entity) {
      let obj = Object.assign({},context.state.entity);
      if(!obj.dayAmount){
        delete obj.dayAmount;
      }
      if(!obj.days){
        delete obj.days;
      }
      context.dispatch("api/put", {
        url: context.state.baseModuleUrl + "/" + entity,
        entity: obj
      }, { root: true })
        .then(function () {
          context.dispatch("base/showSuccess", {
            userAlertSuccessStr: "Success!",
            dismissCountDown: 5,
            userAlertSuccessVisible: false,
          }, { root: true }).then(function () {
            context.dispatch("api/get", {
              url: context.state.baseModuleUrl + "/" + entity + "/findAllByPlanCode/" + context.state.entity.planCode
            }, { root: true })
              .then(response => {
                //console.log("======="+response);
                context.commit('formulaPlanDetails' + "/setRows", response, { root: true });
              });
          })
        })



    },
    getDetails(context, planCode) {
      const entity = 'formulaPlanDetails'
      // 发送请求
      context.dispatch("api/get", {
        url: context.state.baseModuleUrl + "/" + entity + "/findAllByPlanCode/" + planCode
      }, { root: true }).then(response => {
        // console.log(response[0]);
        context.commit('formulaPlanDetails' + "/setRows", response, { root: true });
      });
    }

  })
  .buildStore()







